const newBridge = () =>
  typeof window !== "undefined" ? window.desktopOfflineMutations : null;

const legacyBridgeFor = (entityType) =>
  entityType === "order" ? window.desktopOrderQueue : window.desktopProductQueue;

const toLegacyProductEntry = (mutation) => ({
  id: mutation.id,
  restaurantId: mutation.restaurantId,
  operation: mutation.entityType === "category"
    ? `category-${mutation.action}`
    : mutation.action,
  payload: {
    ...(mutation.metadata || {}),
    endpoint: mutation.endpoint,
    fields: mutation.payload,
    requestType: mutation.metadata?.transport === "json" ? "json" : undefined,
  },
});

const fromLegacyProductEntry = (entry) => ({
  id: entry.id,
  restaurantId: entry.restaurantId,
  entityType: String(entry.operation || "").startsWith("category-") ? "category" : "product",
  action: String(entry.operation || "").replace(/^category-/, ""),
  endpoint: entry.payload?.endpoint,
  payload: entry.payload?.fields || {},
  metadata: entry.payload || {},
  attempts: entry.attempts,
  status: entry.status,
  lastError: entry.lastError,
  createdAt: entry.createdAt,
});

export const enqueueMutation = async (mutation) => {
  if (newBridge()) return newBridge().enqueue(mutation);
  const legacy = legacyBridgeFor(mutation.entityType);
  if (!legacy) return null;
  if (mutation.entityType === "order") {
    return legacy.enqueue({
      id: mutation.id,
      restaurantId: mutation.restaurantId,
      endpoint: mutation.endpoint,
      payload: mutation.payload,
    });
  }
  return legacy.enqueue(toLegacyProductEntry(mutation));
};

export const listMutations = async (filters = {}) => {
  if (newBridge()) return newBridge().list(filters);
  const entityTypes = filters.entityTypes || (filters.entityType ? [filters.entityType] : []);
  const wantsOrders = entityTypes.includes("order");
  const bridge = wantsOrders ? window.desktopOrderQueue : window.desktopProductQueue;
  if (!bridge) return [];
  const rows = await bridge.list(filters);
  if (wantsOrders) return rows.map((entry) => ({ ...entry, entityType: "order", action: /\/edit\/order$/i.test(entry.endpoint) ? "update" : "create" }));
  return rows.map(fromLegacyProductEntry).filter((entry) =>
    !entityTypes.length || entityTypes.includes(entry.entityType));
};

export const removeMutation = async (mutation) => {
  if (newBridge()) return newBridge().remove({ id: mutation.id, entityType: mutation.entityType });
  return legacyBridgeFor(mutation.entityType)?.remove({ id: mutation.id });
};

export const markMutationFailure = async (mutation, error, permanent = false) => {
  const payload = {
    id: mutation.id,
    entityType: mutation.entityType,
    error: error?.message || String(error || "Sync failed"),
    permanent,
  };
  if (newBridge()) return newBridge().markFailure(payload);
  return legacyBridgeFor(mutation.entityType)?.markFailure(payload);
};
